import { useEffect, useState } from 'react';

import FingerprintJS from '@fingerprintjs/fingerprintjs';

export function useVisitorId() {
	// States
	const [visitorId, setVisitorId] = useState<string | null>(null);
	const [visitorIdLoading, setVisitorIdLoading] = useState<boolean>(true);

	// Effects
	useEffect(() => {
		const getVisitorId = async () => {
			const fp = await FingerprintJS.load();

			const { visitorId } = await fp.get();

			setVisitorId(visitorId);
			setVisitorIdLoading(false);
		};

		getVisitorId();
	}, []);

	return { data: visitorId, isLoading: visitorIdLoading };
}
